<template>
  <div>
    <v-container fluid>
      <v-row class="ma-0" justify="space-around">
        <!-- Datos del denunciante-->
        <v-col cols="12" lg="6" class="my-2 pa-0">
          <v-form :v-model="true">
            <v-row class="ma-0" justify="space-between" align="center">
              <v-col cols="12" class="px-0 pb-2">
                <p class="formTitle my-0">
                  {{$t('datFormsTitles.comUserData')}}
                </p>
              </v-col>
              <!-- Si la denuncia proviene de una fuente externa, no mostramos el switch, ya que no existirá usuario identificado y 
              la gestión de los datos irá por WS públicos -->
              <v-col cols="12">
                <v-switch inset v-model="dViewUserData" 
                          color="datPrimary" 
                          hide-details 
                          :disabled="!dEditable" 
                          :label="$t('compDetails.anonymousYn')"
                          class="mt-0">
                </v-switch>   
              </v-col>
              <v-col v-if="dComplaintData.anonymousYn == 'N'" cols="12" md="8">
                <v-text-field v-model="dComplaintData.userName" 
                              :id="('dComplaintData.userName')" 
                              :disabled="!dEditable" 
                              :label="$t('labels.creationUser')"
                              item-color="datPrimary" 
                              color="datPrimary" 
                              class="mt-0" 
                              hide-details/>
              </v-col>
              <v-col v-if="dComplaintData.anonymousYn == 'N'" cols="12" md="5">
                <v-text-field v-model.number="dComplaintData.telephone" 
                              :id="('dComplaintData.telephone')" 
                              :disabled="!dEditable"  
                              :label="$t('compDetails.telephone')"
                              item-color="datPrimary" 
                              color="datPrimary" 
                              hide-details
                              class="mt-0" 
                              />
              </v-col>
              <v-col cols="12" md="7">
                <v-text-field v-model="dComplaintData.email" 
                              :id="('dComplaintData.email')" 
                              :disabled="!dEditable"  
                              :label="dComplaintData.anonymousYn == 'N' ? $t('compDetails.email') : $t('compDetails.email') + $t('compDetails.optional')"
                              item-color="datPrimary" 
                              color="datPrimary" 
                              hide-details
                              class="mt-0" 
                              />
              </v-col>
              <v-col v-if="dComplaintData.anonymousYn == 'S' && dEditable"  cols="6">
                <v-autocomplete v-model="dComplaintData.secQuestion"
                                :label="$t('compDetails.secQuestion')+'*'" 
                                :items="dSecQuestions" 
                                :disabled="!dEditable"           
                                item-color="datPrimary" 
                                hide-details
                                color="datPrimary"  
                                class="mt-0"/>
              </v-col>
              <v-col v-if="dComplaintData.anonymousYn == 'S' && dEditable"  cols="6" >
                <v-text-field v-model="dComplaintData.secAnswer" 
                              :id="('dComplaintData.secAnswer')" 
                              :disabled="!dEditable"
                              :label="$t('compDetails.secAnswer')+'*'"
                              item-color="datPrimary" 
                              color="datPrimary" 
                              hide-details
                              class="mt-0" />
              </v-col>
              <v-col v-if="dComplaintData.status !== 'NUEVA' && !this.pEditable" cols="12">
                <v-row justify="end">
                  <v-btn depressed class="datPrimaryBtn ma-3" @click="fDownloadReceipt">{{$t('datBtn.receipt')}}</v-btn>  
                </v-row>   
              </v-col>
            </v-row>
            <!-- Descripción de la denuncia -->
            <v-row class="ma-0" justify="space-between" align="center">
              <v-col cols="12" class="px-0 pt-4 pb-2">
                <p class="formTitle my-0">
                  {{$t('datFormsTitles.comGeneralData')}}
                </p>
              </v-col>

              <v-col cols="12" md="7" >
                <v-text-field v-model="dComplaintData.title" 
                              :id="('dComplaintData.title')" 
                              :disabled="!dEditable"
                              maxlength='100'
                              :label="$t('datTableHeader.title')+'*'"
                              item-color="datPrimary" 
                              hide-details
                              color="datPrimary" 
                              class="mt-0" />
              </v-col>
              <v-col cols="12" md="5">
                <v-autocomplete v-model="dComplaintData.typeId"
                                :label="$t('compDetails.typeId')+'*'" 
                                :items="dComplaintTypes" 
                                :disabled="!dEditable"
                                item-value="typeId" 
                                hide-details
                                item-text="typeDescription"  
                                item-color="datPrimary" 
                                color="datPrimary"  
                                class="mt-0"/>
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea v-model="dComplaintData.description"  
                            auto-grow 
                            :id="('dComplaintData.description')" 
                            :disabled="!dEditable" 
                            maxlength='4000'
                            hide-details
                            :label="$t('datGeneric.description')"
                            item-color="datPrimary" 
                            color="datPrimary" 
                            class="mt-0" 
                            rows="2" />
              </v-col>
            </v-row>
            <!-- Ficheros y política de privacidad -->
            <v-row>
              <v-col v-if="dFiles.length > 0" cols="12"> 
                <eComplaintFilesTable :pFiles="dFiles" :pShowSnackbar="pShowSnackbar" @update="fUpdatedFilesFromTable" />
              </v-col>           
              <!-- Botón añadir ficheros -->
              <v-col cols="12"> 
                <v-row justify="end">
                  <v-btn depressed class="datPrimaryBtn mr-6" @click="fShowFilesModal">{{$t('btn.addFile')}}</v-btn>             
                  <v-btn v-if="dUpdatedFiles && dFiles.length > 0" depressed class="datPrimaryBtn mr-6" @click="fAddNewFiles">{{$t('datBtn.save')}}</v-btn>             
                </v-row>
              </v-col>
              <v-col cols="12"> 
                <v-switch inset v-model="dComplaintData.privacyYn" 
                          color="datPrimary" 
                          hide-details 
                          true-value="S" false-value="N"
                          :disabled="!dEditable" >
                  <template v-slot:label>
                    <span class="forgotPassword" @click="fShowPrivacyModal(true)">{{$t('compDetails.privacyYn')}}</span>
                  </template>
                </v-switch>   
              </v-col>              
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <!-- Componente de subida de ficheros -->
    <datModal v-if="dShowModal" v-model="dShowModal" :pWidth="700" :pTitle="$t('datFormsTitles.filesUpload')">
      <eComplaintFileUpload :pShowSnackbar="pShowSnackbar" 
                            :key="dShowModal" 
                            @close-modal="fAddFilesToComplaint"></eComplaintFileUpload>
    </datModal>  
    <!-- Modal de Privacidad -->
    <datModal v-if="dShowPrivacy" v-model="dShowPrivacy" :pWidth="900" :pTitle="$t('privacy.title')" >
      <eComplaintPrivacyModal :key="dShowPrivacy" @close="fShowPrivacyModal(false)"  />
    </datModal>  
  </div>
</template>
<script>

//Servicios y mixins
import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'
import ServiceEcomplaints from '@/services/srv-eComplaints'
import ServiceEcomplaintsPublic from '@/services/srv-eComplaintsPublic'

//Componentes
import datModal from '@/components/datModal'
import eComplaintFileUpload from '@/components/EComplaints/complaintDetail/modals/eComplaintFileUpload' 
import eComplaintPrivacyModal from '@/components/EComplaints/complaintDetail/modals/eComplaintPrivacyModal' 
import eComplaintFilesTable from '@/components/EComplaints/complaintDetail/modals/eComplaintFilesTable' 


export default {

  components: {
    eComplaintFileUpload,
    eComplaintPrivacyModal,
    eComplaintFilesTable,
    datModal
  },

  mixins: [mxCanalDenuncias],

  props: {
    pShowSnackbar:{
      type: String,
      default: 'BOTH' // SON PARENT BOTH
    },
    pEditable:{
      type: Boolean,
      required: true
    },
    pComplaintInfo:{
      type: Object,
      required: false
    }
  },
 
  created(){ 
    this.dComplaintData.anonymousYn = 'N'
    this.fGetComplaintTypes()
   
    // Si la denuncia ya está introducida, recuperamos los datos
    if (!this.pEditable){
      this.fGetComplaintFiles()
      this.fGetComplaintData()
    } else if (!this.dExternalOrigin && this.dEditable){
      // Si es nueva e identificada, recuperamos los datos del usuario
      this.fGetUserData()
    } 
  },

  data () {
    return {
      dExternalOrigin: localStorage.getItem("externOrigin"),
      dEditable: this.pEditable,
      dUpdatedFiles: false,
      dShowTerms: false,
      dShowPrivacy: false,
      dComplaintTypes:[],
      dComplaintData:{},
      dViewUserData: false,
      dShowModal:false,
      dItemKey: 'name',
      dSelectedItem: null,
      dLoadingFiles: false,
      dFiles: [],
      dTableHeaders: [
        {
          text: this.$t('datTableHeader.name'),
          value: 'name',
          align: 'left',
          sortable: false,
          class: '',
        },{
          text: this.$t('datTableHeader.date'),
          value: 'date',
          align: 'left',
          sortable: false,
          class: '',
        },{
          text: this.$t('datTableHeader.size'),
          value: 'size',
          align: 'left',
          sortable: false,
          class: '',
        },{
          text: this.$t('datTableHeader.actions'),
          value: 'actions',
          align: 'center',
          sortable: false,
          class: '',
        }
      ], 
      rules: {
        required: value => !!value || 'Field is required',
      },        
    }
  },
  methods: {
    // Recupera la lista de tipos de denuncias
    fGetComplaintTypes(){
      if (this.dExternalOrigin){
        ServiceEcomplaintsPublic.getComplaintTypes({}).then(response => {
          if (response.statusCode == '200' && response.result != 'ko'){
            this.dComplaintTypes = response.dataRes
          }
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }else{
        ServiceEcomplaints.getComplaintTypes({}).then(response => {
          if (response.statusCode == '200' && response.result != 'ko'){
            this.dComplaintTypes = response.dataRes
          }
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }      
    },

    //Recupera los datos generales del sobre
    fGetComplaintData(){
      let payload = {
        complaintId: this.pComplaintInfo.complaintId
      }
      //Recuperamos los datos principales de la denuncia
      if (this.dExternalOrigin){
        ServiceEcomplaintsPublic.getComplaintData(payload).then(response => {
          this.dComplaintData = global.structuredClone(response.dataRes[0])
          this.dViewUserData = this.dComplaintData.anonymousYn == 'S'
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }else{
        ServiceEcomplaints.getComplaintData(payload).then(response => {
          this.dComplaintData = global.structuredClone(response.dataRes[0])
          this.dViewUserData = this.dComplaintData.anonymousYn == 'S'
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }      
    },  

    // Actualiza el data con las modificaciones internas del componente de ficheros
    fUpdatedFilesFromTable(files){
      this.dFiles = files
    },  
    
    // Llama al ws que añade los ficheros nuevos a una denuncia ya introducida
    fAddNewFiles(){
      let payload = {
        complaintId: this.pComplaintInfo.complaintId,
        files: this.dFiles
      }
      //Recuperamos los datos principales de la denuncia
      if (this.dExternalOrigin){
        ServiceEcomplaintsPublic.updateComplaintFiles(payload).then(response => {
          if (response.statusCode == '200' && response.result != 'ko'){
            this.fSnackBarSuccess( this.$t('datAlert.filesAdded'))
            this.dUpdatedFiles = false
            this.fGetComplaintFiles()
          }
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }else{
        ServiceEcomplaints.updateComplaintFiles(payload).then(response => {
          if (response.statusCode == '200' && response.result != 'ko'){
            this.fSnackBarSuccess( this.$t('datAlert.filesAdded'))
            this.dUpdatedFiles = false
            this.fGetComplaintFiles()
          }
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }  
    },

    // Recupera los ficheros asociados a la denuncia
    fGetComplaintFiles(){
      this.dLoadingFiles = true
      let payload = {
        complaintId: this.pComplaintInfo.complaintId
      }
      
      if (this.dExternalOrigin){
        ServiceEcomplaintsPublic.getComplaintFiles(payload).then(response => {
          this.dFiles = response.dataRes
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        }).finally(() => {
          this.dLoadingFiles = false
        })
      }else{
        ServiceEcomplaints.getComplaintFiles(payload).then(response => {
          this.dFiles = response.dataRes
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        }).finally(() => {
          this.dLoadingFiles = false
        })
      }       
    },

    //Recupera los datos principales de la denuncia
    fGetUserData(){
      ServiceEcomplaints.getUserData({}).then(response => {
        if (response.statusCode == '200' && response.result != 'ko'){
          this.dComplaintData.userName    = response.dataRes[0].userName
          this.dComplaintData.telephone  = response.dataRes[0].telephone  
          this.dComplaintData.email      = response.dataRes[0].email
        }
      }).catch(error => {
        this.fSnackbarError(error, this.pShowSnackbar)
      })
    },

    fShowPrivacyModal(show){
      this.dShowPrivacy = show
    },

    fShowTermsModal(show){
      this.dShowTerms = show
    },
  
    // Abre o cierra la modal de subida de ficheros
    fShowFilesModal (){
      this.dShowModal = true
    },

    // Añade los ficheros la tabla de ficheros añadidos 
    fAddFilesToComplaint(files){
      this.dShowModal = false
      // Si se han añadido nuevos ficheros cuando la denuncia no es nueva, damos opción de actualizar la lista de ficheros (botón)
      if(!this.dEditable){
        this.dUpdatedFiles = true
      }
      this.dFiles = this.dFiles.concat(files)  
    },

    // Llama al ws que devuelve la info de acepción de la denuncia y genera el pdf
    fDownloadReceipt(){
      // Función en misxin que recupera y formatea pdf
      this.fDownloadPdfFile( 'CD_RECEIPT_PDF', this.pComplaintInfo.complaintId, this.dComplaintData.auxId ) 
    }
  },
  watch:{
    pComplaintData: {
      deep:true,
      handler(){
        this.dComplaintData = this.pComplaintData
      }
    },
    pEditable(){
      this.dEditable = this.pEditable
    },
    dViewUserData(){
      if (this.dViewUserData) {
        this.dComplaintData.anonymousYn  = 'S'
      }else{
        this.dComplaintData.anonymousYn  = 'N'
      }
    },
    dComplaintData(){
      this.$emit('updatedData', this.dComplaintData) 
    },
    dFiles(){
      this.dComplaintData.files = this.dFiles
    }
  }
}
</script>